import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { GalleryClient } from "../../parentApi";

const client = new GalleryClient(app_uri, axiosClient());

export default client;
